import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SidebarIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("rect", {
    x: "2",
    y: "3.97",
    width: "12",
    height: "16",
    rx: "1"
  }), /*#__PURE__*/_jsx("rect", {
    x: "16",
    y: "3.97",
    width: "6",
    height: "16",
    rx: "1"
  })]
}), 'SidebarIcon');